var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate",
    transform: "translate(16.206 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-16.206 -78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M70.589,181.506H59.715a.425.425,0,1,0,0,.849H70.589a.425.425,0,1,0,0-.849Z",
    transform: "translate(-56.09 -171.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M70.589,234.2H59.715a.425.425,0,1,0,0,.85H70.589a.425.425,0,1,0,0-.85Z",
    transform: "translate(-56.09 -220.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M70.589,286.9H59.715a.425.425,0,1,0,0,.849H70.589a.425.425,0,1,0,0-.849Z",
    transform: "translate(-56.09 -270.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M71.014,340.019a.425.425,0,0,0-.425-.425H59.715a.425.425,0,0,0,0,.85H70.589A.425.425,0,0,0,71.014,340.019Z",
    transform: "translate(-56.09 -320.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M59.715,416.821a.425.425,0,0,0,0,.85h5.451a.425.425,0,0,0,0-.85Z",
    transform: "translate(-56.09 -393.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M168.229,54.038V52.659a.953.953,0,0,0-.952-.952h-8.721a.953.953,0,0,0-.952.952v1.378a.953.953,0,0,0,.952.952h.736a.425.425,0,0,0,0-.849h-.736a.1.1,0,0,1-.1-.1V52.659a.1.1,0,0,1,.1-.1h8.721a.1.1,0,0,1,.1.1v1.378a.1.1,0,0,1-.1.1h-6a.425.425,0,1,0,0,.849h6A.953.953,0,0,0,168.229,54.038Z",
    transform: "translate(-148.682 -48.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M25.674,25.9a.428.428,0,0,0-.431.425V26.9a1.262,1.262,0,0,1-1.269,1.252H4.925A1.262,1.262,0,0,1,3.655,26.9V6.481a1.244,1.244,0,0,1,.03-.27H7.606A1.476,1.476,0,0,0,9.091,4.747V.879A1.294,1.294,0,0,1,9.364.85h14.61A1.262,1.262,0,0,1,25.244,2.1V7.757a.431.431,0,0,0,.861,0V2.1A2.119,2.119,0,0,0,23.974,0H9.364A2.132,2.132,0,0,0,7.858.616L3.418,5a2.074,2.074,0,0,0-.624,1.486V26.9A2.119,2.119,0,0,0,4.925,29h19.05A2.119,2.119,0,0,0,26.1,26.9v-.572a.428.428,0,0,0-.431-.425ZM8.23,1.45v3.3a.62.62,0,0,1-.623.615H4.264Z",
    transform: "translate(-2.794 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M305.262,170.369a1.7,1.7,0,0,0-.83-2.555.844.844,0,0,1-.562-.773,1.7,1.7,0,0,0-2.173-1.579.844.844,0,0,1-.909-.3,1.7,1.7,0,0,0-2.687,0,.844.844,0,0,1-.909.3,1.7,1.7,0,0,0-2.173,1.579.844.844,0,0,1-.562.773,1.7,1.7,0,0,0-.83,2.555.844.844,0,0,1,0,.956,1.7,1.7,0,0,0,.83,2.555.844.844,0,0,1,.562.773,1.7,1.7,0,0,0,1.467,1.631v3.867a.9.9,0,0,0,1.374.768l1.558-.959a.045.045,0,0,1,.054,0l1.558.959a.9.9,0,0,0,1.374-.768v-3.867a1.7,1.7,0,0,0,1.467-1.631.844.844,0,0,1,.562-.773,1.7,1.7,0,0,0,.83-2.555A.843.843,0,0,1,305.262,170.369Zm-3.787,9.827-1.558-.959a.9.9,0,0,0-.945,0l-1.558.959a.052.052,0,0,1-.079-.044V176.2a.843.843,0,0,1,.766.324,1.7,1.7,0,0,0,2.687,0,.843.843,0,0,1,.766-.324v3.948A.052.052,0,0,1,301.474,180.2Zm3.085-8.393a.849.849,0,0,1-.415,1.277,1.689,1.689,0,0,0-1.124,1.547.837.837,0,0,1-.306.627.846.846,0,0,1-.781.162,1.689,1.689,0,0,0-1.819.591.849.849,0,0,1-1.343,0,1.688,1.688,0,0,0-1.338-.66,1.714,1.714,0,0,0-.481.069.846.846,0,0,1-.781-.162.837.837,0,0,1-.306-.627,1.689,1.689,0,0,0-1.124-1.547.849.849,0,0,1-.415-1.277,1.689,1.689,0,0,0,0-1.913.849.849,0,0,1,.415-1.277,1.689,1.689,0,0,0,1.124-1.547.849.849,0,0,1,1.086-.789,1.689,1.689,0,0,0,1.819-.591.849.849,0,0,1,1.343,0,1.689,1.689,0,0,0,1.819.591.849.849,0,0,1,1.086.789,1.689,1.689,0,0,0,1.124,1.547.849.849,0,0,1,.415,1.277A1.689,1.689,0,0,0,304.56,171.8Z",
    transform: "translate(-276.558 -155.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M341.974,213.583a3.56,3.56,0,1,0,3.56,3.56A3.564,3.564,0,0,0,341.974,213.583Zm0,6.271a2.711,2.711,0,1,1,2.71-2.711A2.714,2.714,0,0,1,341.974,219.854Z",
    transform: "translate(-319.088 -201.486)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificate);
export default __webpack_public_path__ + "static/media/icon_certificate.8435cf5f2bb28b29d72b2bc97cf05e61.svg";
export { ForwardRef as ReactComponent };